import { Check, X } from "lucide-react";

interface PasswordRequirement {
  label: string;
  validator: (password: string) => boolean;
}

const requirements: PasswordRequirement[] = [
  {
    label: "At least 8 characters",
    validator: (password) => password.length >= 8,
  },
  {
    label: "At least 1 uppercase letter",
    validator: (password) => /[A-Z]/.test(password),
  },
  {
    label: "At least 1 lowercase letter",
    validator: (password) => /[a-z]/.test(password),
  },
  {
    label: "At least 1 number",
    validator: (password) => /[0-9]/.test(password),
  },
  {
    label: "At least 1 special character",
    validator: (password) => /[!@#$%^&*(),.?":{}|<>]/.test(password),
  },
];

interface PasswordStrengthValidatorProps {
  password: string;
}

export function PasswordStrengthValidator({
  password,
}: PasswordStrengthValidatorProps) {
  return (
    <div className="mt-2 space-y-2">
      {requirements.map((requirement, index) => {
        const isMet = requirement.validator(password);
        return (
          <div key={index} className="flex items-center gap-2 text-sm">
            {isMet ? (
              <Check className="h-4 w-4 text-success" />
            ) : (
              <X className="h-4 w-4 text-destructive" />
            )}
            <span className={isMet ? "text-success" : "text-destructive"}>
              {requirement.label}
            </span>
          </div>
        );
      })}
    </div>
  );
}
